import React from 'react';
import {AppDownloadModal} from './AppDownloadModal';
import {SERP} from '../notification-config';
export const AppDownloadModalWrapper = ({notification, page}) => {
    const imgUrl = notification.logo.url;
    const title = notification.title.items[0].text;
    const description = notification.body[0].items[0].text;
    const link = notification.containerLink.uri.value;
    const ctaButtonLabel = notification.form.title;
    const dismissLabel = notification.dismiss.icon.description;
    const useCanonicalPath =
        page && page.toLowerCase() === SERP.toLowerCase() ? true : false;
    return (
        <AppDownloadModal
            imgUrl={imgUrl}
            title={title}
            description={description}
            ctaLink={link}
            useCanonicalPath={useCanonicalPath}
            dismissLabel={dismissLabel}
            ctaButtonLabel={ctaButtonLabel}
        />
    );
};
